export default ({$fetcher: fetchData}) => {
  return {
    namespaced: true,
    state: {
      certificate: null,
    },
    actions: {
      sendPoliceCertificateFile({rootGetters}, params) {
        return new Promise((resolve, reject) => {
          fetchData.sendPoliceCertificate(params, rootGetters['UserInfoStore/userUid']).then((data) => {
            resolve(data);
          }).catch((error) => {
            reject(error);
          });
        });
      },
      getPoliceCertificate({rootGetters, commit}) {
        return new Promise((resolve, reject) => {
          fetchData.fetchPoliceCetrificate(rootGetters['UserInfoStore/userUid']).then((data) => {
            commit('setCertificate', data);
            resolve(data);
          }).catch((error) => {
            reject(error);
          });
        });
      },
      downloadPurposeLetter({rootGetters}) {
        return new Promise((resolve, reject) => {
          fetchData.downloadPurposeLetter(rootGetters['UserInfoStore/userUid']).then((data) => {
            resolve(data);
          }).catch((error) => {
            reject(error);
          });
        });
      }
    },
    mutations: {
      setError(state, {fieldName, errorText}) {
        state.errors[fieldName].errors = [...state.errors[fieldName].errors, errorText];
      },
      removeOneError(state, fieldName) {
        state.errors[fieldName].errors = [];
      },
      removeErrors(state) {
        for (const key of Object.keys(state.errors)) {
          state.errors[key].errors = [];
        }
      },
      setCertificate(state, value) {
        state.certificate = value;
      },
      clearStore(state) {
        state.certificateFile = '';
      }
    }
  };
};
